import { render, staticRenderFns } from "./opcr-logs.vue?vue&type=template&id=f4dc2a58&"
import script from "./opcr-logs.vue?vue&type=script&lang=js&"
export * from "./opcr-logs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports